/* =====================================================================
 * docAgentSlot — DI slot for the DocAgent mode page component.
 *
 * `features/docAgent/` in the B2C host is a large (~410 files) feature
 * bundle that owns the document-editor surface (TipTap editors,
 * toolbars, docx-related bridges, ...).  Hoisting it into
 * `@auw/workspace-features` is a separate, large migration (tracked as
 * a later pass) because most of its files deeply couple to local store
 * slices, editors, and B2C-specific auth.  In the meantime, shared
 * shells (`WorkspaceRouter`, `WorkspaceShell`) still need to render
 * "mode: doc-agent" without importing the host's directory.
 *
 * This slot lets the host register its `DocAgentModePage` component
 * during bootstrap.  `WorkspaceRouter` reads it at render time; when no
 * component has been registered (e.g. a tenant that disables the
 * `mode.doc-agent` feature entirely), it falls back to the generic
 * "preparing" placeholder.
 * ===================================================================== */

import type React from 'react';

export type DocAgentModePageComponent = React.ComponentType;
export type DocAgentLandingPageComponent = React.ComponentType;
export type DocAgentEditorPageComponent = React.ComponentType<{ itemId: string }>;

let _impl: DocAgentModePageComponent | null = null;
let _landingImpl: DocAgentLandingPageComponent | null = null;
let _editorImpl: DocAgentEditorPageComponent | null = null;

export function setDocAgentModePageComponent(
  comp: DocAgentModePageComponent | null,
): void {
  _impl = comp;
}

export function getDocAgentModePageComponent(): DocAgentModePageComponent | null {
  return _impl;
}

export function setDocAgentLandingPageComponent(
  comp: DocAgentLandingPageComponent | null,
): void {
  _landingImpl = comp;
}

export function getDocAgentLandingPageComponent(): DocAgentLandingPageComponent | null {
  return _landingImpl;
}

export function setDocAgentEditorPageComponent(
  comp: DocAgentEditorPageComponent | null,
): void {
  _editorImpl = comp;
}

export function getDocAgentEditorPageComponent(): DocAgentEditorPageComponent | null {
  return _editorImpl;
}
